import {Nav} from "rsuite";

const styles = {
    marginBottom: '1rem',
};

const ReportingExploreNav = ({ active, onSelect, ...props }) => {
    return (
        <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>
            <Nav.Item eventKey="education">Education</Nav.Item>
            <Nav.Item eventKey="experience">Experience</Nav.Item>
        </Nav>
    );
};

export default ReportingExploreNav;